/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');
      // AYA (30-oct): con las notas de la bolsa apagadas (cart_drawer_notes) no existe #mini-cart__notes; leerlo
      // tiraba un error antes del fetch y el spinner quedaba girando sin vaciar la bolsa
      const notes = document.getElementById('mini-cart__notes');
      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(notes ? { 'note': notes.value } : {})
      }).then(() => {
        this.drawer.refresh();
      }).finally(() => {
        this.classList.remove('loading');
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}